import * as _ from 'lodash';
import { PageBase, PageOptionsBase } from '../../Common/PageBase';
import { DatatableApi, Datatable, DatatableOptions } from '../../Widgets/Datatable'
import { MultiSelectApi } from '../../Widgets/MultiSelect'
import { Utils } from '../../Utils/Utils';
import { DateUtils } from '../../Utils/DateUtils';
import { StringUtils } from '../../Utils/StringUtils';

var tableId = 'tableConfigurationKeys';
var tableDom = "<'row'<'col-sm-6'l><'col-sm-6'f><'col-sm-6'>>" + "<'row'<'col-sm-12'tr>>" + "<'row'<'col-sm-5'i><'col-sm-7'p>>";

export interface ConfigurationKeysPageOptions extends PageOptionsBase {
    urlList: string;
    urlDetail: string;
    urlPost: string;
    urlClean: string;
    localizer: {
        StatusEnabled: string;
        StatusDisabled: string;
    }
}

export class ConfigurationKeys extends PageBase<ConfigurationKeysPageOptions> {
    private _tableOptions: DatatableOptions;
    private _table: Datatable;
    private _btnAddToExport: JQuery;
    private _btnCleanExport: JQuery;
    private _checkAll: JQuery;
    private _otherCheckAll: JQuery;

    constructor(options: ConfigurationKeysPageOptions) {
        super(options);
        this.addToExport = this.addToExport.bind(this);
        this.cleanExport = this.cleanExport.bind(this);
        this.checkBoxAll = this.checkBoxAll.bind(this);
        window['setSelectAllCheckbox'] = this.setSelectAllCheckbox;

        this._tableOptions = {
            url: this._options.urlList,
            dom: tableDom,
            rowId: 'Code',
            order: [1, "asc"],
            autoWidth: true,
            columns: [
                {
                    sortable: false,
                    render: (data: any, type: any, rowData: any) => {
                        return (`<input id='chckbx${rowData.Code}' name='selectedKey' value='${rowData.Code}' type='checkbox' onClick="setSelectAllCheckbox()" />`);
                    }
                },
                {
                    sortable: false,
                    data: "Code"
                },
                {
                    sortable: false,
                    data: "DisplayName"
                }
            ]
        };
    }

    init(): void {
        this._btnAddToExport = Utils.getJQueryById("btnAddToExport");
        this._btnAddToExport.on("click", this.addToExport);
        this._btnCleanExport = Utils.getJQueryById("btnClearExport");
        this._btnCleanExport.on("click", this.cleanExport);
        this._checkAll = Utils.getJQueryById("keysSelectAll");
        this._checkAll.on("change", this.checkBoxAll);
        this._otherCheckAll = Utils.getJQueryById("selectedKeysSelectAll");
        this._table = new Datatable(tableId, this._tableOptions);
    }

    private addToExport(e: JQueryEventObject): void {
        e.preventDefault();
        var urlPost = this._options.urlPost;
        var table = this._table;
        var selectedTable = Utils.getJQueryById("tableSelectedConfigurationKeys").DataTable();
        var codes = $("input[name='selectedKey']:checked").map(function () {
            return $(this).val();
        });
        var codesToAdd = codes.get();
        if (!codesToAdd || codesToAdd.length === 0) {
            return;
        }
        var checkAll = this._checkAll;
        var otherCheckAll = this._otherCheckAll;
        $.ajax({
            url: urlPost,
            type: "POST",
            dataType: 'html',
            data: { codes: codesToAdd },
            success: function (data) {
                checkAll.prop("checked", false);
                otherCheckAll.prop("checked", false);
                table.draw();
                selectedTable.draw();
            }
        });
    }

    private cleanExport(e: JQueryEventObject): void {
        e.preventDefault();
        var urlClean = this._options.urlClean;
        var table = this._table;
        var selectedTable = Utils.getJQueryById("tableSelectedConfigurationKeys").DataTable();
        $.ajax({
            url: urlClean,
            type: "POST",
            dataType: 'html',
            data: { },
            success: function (data) {
                table.draw();
                selectedTable.draw();
            }
        });
    }

    private checkBoxAll(): void {
        var checkboxes = $("input[name='selectedKey']");
        for (var i = 0; i < checkboxes.length; i++) {
            (<HTMLInputElement>checkboxes[i]).checked = (<HTMLInputElement>this._checkAll[0]).checked;
        }
    }

    private setSelectAllCheckbox(): void {
        var checkboxes = $("input[name='selectedKey']");
        let buildSelectAll = Utils.getJQueryById("keysSelectAll")[0];
        if (Utils.isNullOrUndefined(buildSelectAll))
            return;
        let allCheckboxesChecked = false;
        for (var i = 0; i < checkboxes.length; i++) {
            allCheckboxesChecked = (<HTMLInputElement>checkboxes[i]).checked;
            if (!allCheckboxesChecked)
                break;
        }
        (<HTMLInputElement>buildSelectAll).checked = allCheckboxesChecked;
    }
}


/** WEBPACK FOOTER **
 ** ./Typescript/Pages/ConfigurationOverview/ConfigurationKeys.ts
 **/